import { Component, inject } from '@angular/core';
import { PmDialogComponent } from '@libs/ui';
import { Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { MultiselectFilterComponent } from 'demand-forecasting/components/multiselect-filter/multiselect-filter.component';
import { SaveFilterCombinationComponent } from 'demand-forecasting/components/multiselect-filter/save-filter-combination.component';
import { FilterActions } from 'demand-forecasting/store/filter/filter.actions';
import { selectSelectedFiltersDifferFromAppliedFilters } from 'demand-forecasting/store/filter/filter.selectors';
import { ForecastSeriesActions } from 'demand-forecasting/store/forecast-series/forecast-series.actions';
import { selectForecastSeriesIsPendingOrSaveFilterCombinationPending } from 'demand-forecasting/store/forecast-series/forecast-series.selectors';
import { ConfigurationRouterHelperService } from 'demand-forecasting/store/router-state/configuration-router-helper.service';
import { selectVersionId } from 'demand-forecasting/store/router-state/router.selectors';
import { createFilterDialogState } from './filter-dialog.state';

@Component({
  template: `
    <pm-dialog
      size="lg"
      dialogTitle="FILTER.FILTER_YOUR_FORECAST"
      contentClass="py-8 gap-8"
      [primaryCtaButtonConfig]="state.primaryCtaButton()"
    >
      <pm-multiselect-filter [loading]="state.availableFiltersLoading()" />
      <pm-save-filter-combination
        [form]="state.form"
        [selectedFiltersAsSavedFilterCombination]="
          state.selectedFiltersAsSavedFilterCombination()
        "
      />
    </pm-dialog>
  `,
  imports: [
    MultiselectFilterComponent,
    SaveFilterCombinationComponent,
    TranslateModule,
    PmDialogComponent,
  ],
})
export class FilterDialogComponent {
  private readonly store = inject(Store);
  private readonly routerHelper = inject(ConfigurationRouterHelperService);

  protected readonly state = createFilterDialogState({
    versionId: this.store.selectSignal(selectVersionId),
    isLoading: this.store.selectSignal(
      selectForecastSeriesIsPendingOrSaveFilterCombinationPending,
    ),
    selectedFiltersDifferFromApplied: this.store.selectSignal(
      selectSelectedFiltersDifferFromAppliedFilters,
    ),
    urlParamKey: 'filterCombinationIds',
    onSaveOnly: (name) =>
      this.store.dispatch(
        FilterActions.createAndSaveFilterCombination({ name }),
      ),
    onApplyOnly: (filters) => {
      this.routerHelper.updateSelectedFilterCombinations(null);
      this.store.dispatch(FilterActions.resetFilterCombinationForecastSeries());
      this.store.dispatch(
        ForecastSeriesActions.applyForecastSeriesOptions({
          options: { filters },
        }),
      );
    },
    onSaveAndApply: (name, filters) => {
      this.routerHelper.updateSelectedFilterCombinations(null);
      this.store.dispatch(FilterActions.resetFilterCombinationForecastSeries());
      this.store.dispatch(
        ForecastSeriesActions.applyForecastSeriesOptions({
          options: { filters },
          filterCombinationName: name,
        }),
      );
    },
  });
}
